// query-config.js
// ----------------------------------------------------------------------
export const defaultQueryConfig = {
    staleTime: 60 * 60 * 1000,       // 1 hour
    cacheTime: 24 * 60 * 60 * 1000,  // 24 hours
    refetchOnWindowFocus: false,     // Disable refetch on window focus
    refetchOnReconnect: false,       // Disable refetch on reconnect
}